import { render, staticRenderFns } from "./BuyVr.vue?vue&type=template&id=354a17ac&scoped=true&"
import script from "./BuyVr.vue?vue&type=script&lang=js&"
export * from "./BuyVr.vue?vue&type=script&lang=js&"
import style0 from "./BuyVr.vue?vue&type=style&index=0&id=354a17ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354a17ac",
  null
  
)

component.options.__file = "BuyVr.vue"
export default component.exports